import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FacialRecognitionService {
  private triggerFacialImage = new Subject<void>();
  facialObservable$ = this.triggerFacialImage.asObservable();

  constructor(private api: ApiService) {}
  uploadedImage: FormControl = new FormControl();
  formData: FormControl = new FormControl();
  isUploadInfo: boolean;
  goToStep: number;

  fetchFacialImage(memberId: string): Observable<Blob> {
    this.triggerFacialImage.next();
    return this.api.getFile('facial/image?memberId=' + memberId);
  }

  generateFacialImageByLink() {
    return this.api.post('facial/GenerateLink', '');
  }

  uploadFacialImage(formData: FormData) {
    return this.api.uploadFacialForm('facial', formData);
  }

  uploadFacialImageWithKey(formData: FormData, key: string) {
    return this.api.uploadFacialForm('facial/link', formData, key);
  }

  validateFacialKey(key: string) {
    return this.api.validateFacialKey('facial/link', key);
  }
}
